import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Theme } from '@/styles/theme';
import { PaddingProps } from '@/types/ui';

interface Props {
  $width?: number | string;
  $height?: number | string;
  $margin?: PaddingProps;
  $grow?: number;
  $alignSelf?: 'center' | 'flex-start' | 'flex-end' | 'stretch' | 'baseline';
  $rounded?: keyof Theme['rounded'];
}

const KeyframeSkeleton = keyframes`
0% {
  transform: translateX(-80%);
}
50% {
  transform: translateX(50%);
}
100% {
  transform: translateX(180%);
}
`;

const Root = styled.div<Props>`
  display: flex;
  border-radius: 12px;
  overflow: hidden;
  background-color: #ffffff1c;

  ${(p) => p.theme.rounded[p.$rounded ?? 'md']};

  flex-grow: ${(p) => p.$grow ?? 'initial'};
  align-self: ${(p) => p.$alignSelf ?? 'normal'};
  width: ${(p) =>
    typeof p.$width === 'string'
      ? p.$width
      : typeof p.$width === 'number'
        ? `${p.$width}px`
        : 'unset'};
  height: ${(p) =>
    typeof p.$height === 'string'
      ? p.$height
      : typeof p.$height === 'number'
        ? `${p.$height}px`
        : '48px'};
  margin: ${(p) =>
    typeof p.$margin === 'object'
      ? `${p.theme.size[p.$margin.y]} ${p.theme.size[p.$margin.x]}`
      : p.theme.size[p.$margin ?? 'zero']};
`;
const Progress = styled.div`
  flex-grow: 1;
  background: linear-gradient(
    90deg,
    #ffffff00 0%,
    #1f273c80 21.77%,
    #ffffff00 100%
  );

  animation-name: ${KeyframeSkeleton};
  animation-timing-function: cubic-bezier(0, 0, 1, 1);
  animation-duration: 1.8s;
  animation-iteration-count: infinite;
`;

function Skeleton(props: Props) {
  return (
    <Root {...props}>
      <Progress />
    </Root>
  );
}

export default Skeleton;
